import { useLocale } from 'src/lib/hooks/useLocal'
import InputTextField from 'src/components/common/form-elements/InputTextField'
import { Info } from 'react-feather'
import { useRewardsContext } from 'src/lib/contexts/RewardsConfigContext'
import CopyTextButton from 'src/components/common/form-elements/CopyTextButton'
import { useEffect } from 'react'
import { useRewardsPermissions } from 'src/lib/access-permission-hooks/useRewardsPermissions'
const EarnMessage = () => {
  const { t } = useLocale()
  const earnMessage = useRewardsContext(context => context.state?.earnMessage)
  const setEarnMessage = useRewardsContext(context => context.actions?.setEarnMessage)
  const earnTileCustomiseUi = useRewardsContext(context => context.state?.earnTileCustomiseUi)

  const { canEditRewardsCustomisation } = useRewardsPermissions()

  const isIputEnable = canEditRewardsCustomisation ? !earnMessage?.enable : true
  useEffect(() => {
    if (earnTileCustomiseUi?.isCreditNameVisible === 'block') {
      setEarnMessage({
        ...earnMessage,
        line_1: earnMessage?.line_1.substring(0, 48),
        line_2: earnMessage?.line_2.substring(0, 40)
      })
    }
  }, [earnTileCustomiseUi?.isCreditNameVisible])
  return (
    <div className='flex pb-1 flex-col gap-3'>
      <h2 className='font-medium text-base text-coal-dark '>{t('earn_message')}</h2>

      <div className='flex flex-col gap-2 bg-white border-1 border-solid border-[rgba(199,152,31,0.40)] border rounded border-gray-light '>
        <div className='flex items-start gap-2 p-2 rounded-t-lg bg-[#FDFAF2]'>
          <Info className='h-4 w-4 stroke-[2.5px] mt-0.5' color={'#C7981F'} />
          <div className='flex flex-col'>
            <p className='text-sm font-medium text-carbon pt-0.5'>{t('variable_text_for_earn_and_rupees_value')}</p>
          </div>
        </div>
        <div className='p-2 pt-0 gap-2'>
          <div className='flex flex-row mb-2'>
            <p className='text-xs font-normal'>{'Use '}</p>
            <div className='relative group mt-[-6px]'>
              <span className='rounded-lg mx-[1.5px] pt-0 px-0.5 text-xs pb-0.5 font-medium border-gray-light border-1 hover:border-[#EFD080] text-coal-dark bg-white hover:bg-yellow-200/10 '>{`<Rewards_value>`}</span>
              <div className='absolute opacity-0 font-[IBM Plex Mono] text-[#FFF] ml-10 font-normal text-sm group-hover:opacity-100 cursor-pointer p-1 bg-coal-dark rounded flex flex-row z-10'>
                <CopyTextButton message={'Successfully copied text'} text={'<Rewards_value>'}></CopyTextButton>
                {t('copy')}
              </div>
            </div>
            <p className='text-xs font-normal'>{' to show the rewards being earned on purchase.'}</p>
          </div>
          <div className='flex flex-row'>
            <p className='text-xs font-normal'> {'Use'} </p>
            <div className='relative group mt-[-6px]'>
              <span className='rounded-lg pt-0 px-0.5 mx-[1.5px] text-xs pb-0.5 font-medium  border-gray-light border-1 hover:border-[#EFD080] text-coal-dark bg-white hover:bg-yellow-200/10'>{`<Rupees_value>`}</span>
              <div className='absolute opacity-0 font-[IBM Plex Mono] text-[#FFF] ml-10 font-normal text-sm group-hover:opacity-100 cursor-pointer p-1 bg-coal-dark rounded flex flex-row z-10'>
                <CopyTextButton message={'Successfully copied text'} text={'<Rupees_value>'}></CopyTextButton>
                {t('copy')}
              </div>
            </div>
            <p className='text-xs font-normal'>{' to show the value of those rewards in ₹ Rupees.'}</p>
          </div>
        </div>
      </div>
      <div className='flex flex-col w-full  gap-2 '>
        <div className='flex flex-col justify-between w-full  gap-1'>
          <div className='font-inter text-sm font-medium leading-4 text-left tracking-normal text-gray-dark'>
            {t('line1')}
          </div>
          <InputTextField
            textFieldId='points'
            inputValue={earnMessage?.line_1}
            inputPlaceholder={t('earn_message_line_1')}
            handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const enteredValue = event?.target?.value
              if (
                (earnTileCustomiseUi?.isCreditNameVisible === 'block' && enteredValue?.length <= 48) ||
                (earnTileCustomiseUi?.isCreditNameVisible === 'none' && enteredValue?.length <= 58)
              )
                setEarnMessage({ ...earnMessage, line_1: enteredValue })
            }}
            delimiters={[['<', '>']]}
            inputType='text'
            isFullWidth={true}
            showCharacterCountConfig={{
              maxLength: earnTileCustomiseUi?.isCreditNameVisible === 'block' ? 48 : 58,
              showOnlyOnFocus: true,
              customClass: 'text-xs font-normal text-gray-500 leading-tight'
            }}
            isDisabled={isIputEnable}
          />
        </div>

        <div className='flex flex-col justify-between w-full gap-1'>
          <div className='font-inter text-sm font-medium leading-4 text-left tracking-normal text-gray-dark'>
            {t('line2')}
          </div>
          <InputTextField
            textFieldId='noPoints'
            handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const enteredValue = event?.target?.value
              if (
                (earnTileCustomiseUi?.isCreditNameVisible === 'block' && enteredValue?.length <= 40) ||
                (earnTileCustomiseUi?.isCreditNameVisible === 'none' && enteredValue?.length <= 50)
              )
                setEarnMessage({ ...earnMessage, line_2: event?.target?.value })
            }}
            delimiters={[['<', '>']]}
            inputValue={earnMessage?.line_2}
            inputType='text'
            isFullWidth={true}
            showCharacterCountConfig={{
              maxLength: earnTileCustomiseUi?.isCreditNameVisible === 'block' ? 40 : 50,
              showOnlyOnFocus: true,
              customClass: 'text-xs font-normal text-gray-500 leading-tight'
            }}
            isDisabled={isIputEnable}
          />
        </div>
      </div>
    </div>
  )
}
export default EarnMessage
